import React from 'react';

export const Footer = () => {
  return (
    <div className="footer">
      <div className="footerContentWrapper">
        <p className="footerItem">Guard Services USA</p>
        <p className="footerItem">420 Lexington Ave, 6th Floor, New York, NY 10170</p>
        <p className="footerItem">24/7 Dispatch (888) 782-3900</p>
        <p className="footerItem">Service@GuardServicesUSA.com</p>
        <p className="footerItem">www.GuardServicesUSA.com</p>
        <p className="footerItem">© 2026 Guard Services USA</p>
      </div>
    </div>
  )
}